import FooterTop from 'Components/FooterTop/FooterTop';
import Additional from 'Components/Home/Additional';
// import Bess from 'Components/Home/Bess';
// import Expanding from 'Components/Home/Expanding';
import Footer from 'Components/Home/Footer';
import Hero from 'Components/Home/Hero';
import Energymangment from 'Components/Home/Energymangment';
import Navbar from 'Components/Home/Navbar';
import React from 'react';
import Stratgeic from 'Components/Home/Stratgeic';

export default function HomePage() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Energymangment />
      {/* <Bess /> */}
      <div>
        <Additional />
      </div>
      <Stratgeic />
      <div className=" relative ">
        {/* <Expanding /> */}
        <FooterTop />
        <Footer />
      </div>
    </div>
  );
}
